import convertLocaleStringToNumber from './convertLocaleStringToNumber';
function removeCurrencySymbol(value) {
  var currencySansSymbol = value.replace(/^\D*/g, '').replace(/\D*$/g, '');
  return value.indexOf('-') === 0 ? "-".concat(currencySansSymbol) : currencySansSymbol;
}
export default function getCurrencyDisplay(value, currency) {
  var includeSymbol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var baseCurrencyDisplay = convertLocaleStringToNumber(value).toLocaleString(undefined, {
    style: 'currency',
    currency: currency
  });
  return includeSymbol ? baseCurrencyDisplay : removeCurrencySymbol(baseCurrencyDisplay);
}